document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll("[data-breadcrumb-title]").forEach((el) => {
    const words = el.textContent.trim().split(/\s+/);

    if (words.length > 3) {
      el.textContent = words.slice(0, 3).join(" ") + "...";
    }
  });

});
